import http from "@/http-common";

export class BaseService<T> {
  public entityUrl = "";

  create(data:T) {
    return http.post<T>(this.entityUrl, data);
  }

  update(data:T) {
    return http.put<T>(this.entityUrl, data);
  }

  find(id: number) {
    return http.get<T>(`${this.entityUrl}/${id}`);
  }

  query(req?: any) {
    const options = createRequestOption(req);
    return http.get<T[]>(this.entityUrl, options);
  }

  delete(id: number) {
    return http.delete(`${this.entityUrl}/${id}`);
  }
}

export const createRequestOption = (req?: any) => {
  const options: any = {}

  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort') {
        if (Array.isArray(req[key])) {
          options[key] = req[key].join(',')
        }else {
          options[key] = req[key];
        }
      }
    });

    if (req.sort) {
      options['sort'] = "";
      req.sort.forEach((val: string, index:number) => {
        if(index > 0) {
          options['sort'] += ","
        }
        options['sort'] += val;

      });
    }
  }

  return { params: options };
};
